export default "__VITE_ASSET__DuL2ybq7__"